/**
 * @generated SignedSource<<9b7a0ad0bfad12897057c4878a7ef945>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightEditPageQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
};
export type FlightEditPageQuery$data = {
  readonly flight: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"FlightEdit_flight" | "FlightSidebar_flight">;
  } | null;
};
export type FlightEditPageQuery = {
  response: FlightEditPageQuery$data;
  variables: FlightEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arrivalDatetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "departDatetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "departAirportCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arrivalAirportCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supplier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flightNumber",
        "storageKey": null
      }
    ],
    "type": "FlightSegment",
    "abstractKey": null
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FlightEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "flight",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FlightSidebar_flight"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FlightEdit_flight"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FlightEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Flight",
        "kind": "LinkedField",
        "name": "flight",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Package",
            "kind": "LinkedField",
            "name": "packages",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updateUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookingToken",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceLive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUpdating",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightPrice",
                    "kind": "LinkedField",
                    "name": "lastSuccessfulUpdate",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provider",
                    "storageKey": null
                  }
                ],
                "type": "Flight",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "forwardSegments",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "returnSegments",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "type": "FlightType",
            "abstractKey": "__isFlightType"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              }
            ],
            "concreteType": "FlightPriceConnection",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightPriceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightPrice",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceChange",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "actualPrice",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceMessage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "97ec89e982c346669510230697c342bb",
    "id": null,
    "metadata": {},
    "name": "FlightEditPageQuery",
    "operationKind": "query",
    "text": "query FlightEditPageQuery(\n  $id: ID!\n  $first: Int!\n  $after: String\n) {\n  flight(id: $id) {\n    name\n    ...FlightSidebar_flight\n    ...FlightEdit_flight\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment FlightDetailsPrice_flight on Flight {\n  priceLive\n  isUpdating\n  lastSuccessfulUpdate {\n    createdAt\n    id\n  }\n  ...FlightListProvider_flight\n}\n\nfragment FlightDetails_flight on FlightType {\n  __isFlightType: __typename\n  ...FlightDetailsPrice_flight\n  forwardSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n}\n\nfragment FlightEditGeneralInfoDetails_flight on Flight {\n  updateUrl\n  priceKey\n  bookingToken\n}\n\nfragment FlightEditGeneralInfo_flight on Flight {\n  id\n  expired\n  ...FlightEditGeneralInfoDetails_flight\n  ...FlightDetails_flight\n}\n\nfragment FlightEditPriceHistory_flight on Flight {\n  id\n  history(first: $first, after: $after) {\n    ...FlightPriceHistoryTable_history\n  }\n}\n\nfragment FlightEdit_flight on Flight {\n  ...FlightEditGeneralInfo_flight\n  ...FlightEditPriceHistory_flight\n}\n\nfragment FlightInfoEndpoint_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoFullSegment_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoSegmentInfo_segment on FlightSegment {\n  supplier\n  flightNumber\n  departDatetime\n  arrivalDatetime\n}\n\nfragment FlightInfo_segments on FlightSegment {\n  arrivalDatetime\n  departDatetime\n  duration\n  ...FlightInfoFullSegment_segment\n  ...FlightInfoEndpoint_segment\n  ...FlightInfoSegmentInfo_segment\n}\n\nfragment FlightListProvider_flight on Flight {\n  provider\n}\n\nfragment FlightPriceChangeIcon_entry on FlightPrice {\n  priceChange\n}\n\nfragment FlightPriceHistoryRow_entry on FlightPrice {\n  priceChange\n  newPrice\n  actualPrice\n  createdAt\n  status\n  serviceMessage\n  ...FlightPriceChangeIcon_entry\n}\n\nfragment FlightPriceHistoryTable_history on FlightPriceConnection {\n  edges {\n    node {\n      id\n      ...FlightPriceHistoryRow_entry\n    }\n  }\n  pageInfo {\n    total\n    ...Table_pageInfo\n  }\n}\n\nfragment FlightSidebarPackages_flight on Flight {\n  packages {\n    id\n    name\n  }\n}\n\nfragment FlightSidebar_flight on Flight {\n  ...EntitySidebar_entity\n  ...FlightStatus_flight\n  ...FlightSidebarPackages_flight\n}\n\nfragment FlightStatus_flight on Flight {\n  expired\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "78c706a539b9eb2208033916b2c70983";

export default node;
